import { createSlice } from '@reduxjs/toolkit';

const sliceFlags = createSlice({
  name: 'examStudentIndex',
  initialState: {
    indexCarusel: 0,
    indexAcardionItem: null,
  },
  reducers: {
    setIndexCarusel(state, action) {
      state.indexCarusel = action.payload;
    },
    setIndexAcardionItem(state, action) {
      state.indexAcardionItem = action.payload;
    },
  },
});

export const { setIndexCarusel, setIndexAcardionItem } = sliceFlags.actions;

export const getIndexCarusel = state => state.examStudentIndex.indexCarusel;
export const getIndexAcardionItem = state => state.examStudentIndex.indexAcardionItem;

export default sliceFlags.reducer;
